// extracted by mini-css-extract-plugin
export default {"text":"CPjDH","img":"bK6ti"};